import { useCallback, useEffect, useRef } from "react";

// Detecta o toque longo (segurar sem arrastar). `iniciar` no pointerdown e
// `cancelar` no pointerup ou quando o dedo começa a arrastar.
const useSegurar = (aoSegurar, ms = 600) => {
	const timer = useRef(null);
	const callback = useRef(aoSegurar);
	callback.current = aoSegurar;

	const cancelar = useCallback(() => {
		clearTimeout(timer.current);
		timer.current = null;
	}, []);

	const iniciar = useCallback(() => {
		cancelar();
		timer.current = setTimeout(() => {
			timer.current = null;
			callback.current();
		}, ms);
	}, [cancelar, ms]);

	useEffect(() => cancelar, [cancelar]);

	return { iniciar, cancelar };
};

export default useSegurar;
